'use client'

import { useEffect } from 'react'
import hljs from 'highlight.js'

export default function HighlightCode() {
  useEffect(() => {
    // This tells highlight.js to scan the page and colorize any <pre><code> blocks
    hljs.highlightAll()
  }, [])

  return null
}
